import { render, staticRenderFns } from "./msg-item.vue?vue&type=template&id=8a4fccc6&scoped=true&"
import script from "./msg-item.vue?vue&type=script&lang=ts&"
export * from "./msg-item.vue?vue&type=script&lang=ts&"
import style0 from "./msg-item.vue?vue&type=style&index=0&id=8a4fccc6&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4fccc6",
  null
  
)

export default component.exports